export function preCalculateActionsColumnWidth(userEvents) {
  var width = 0;
  userEvents.map((event, index) => {
      //9.42 is average width occupied by each character
      //64 is the minimum width of material ui button
      //10 is the margin of each button 
      width = width + (Math.max(event.name.length * 9.42, 64)) + 10
  });

  return width;
}
